import { Table } from "semantic-ui-react";
import React from "react";
import "../../utils/stylesheet.css";
import { PositionTableRow } from "./PositionTableRow";
import { NoRecords } from "../../common/components/NoRecords";
import { useAuth } from "../../utils/Auth";

export const PositionTable = ({ positions, reload, active = true }) => {
  const { user } = useAuth();

  if (positions.length === 0) {
    return (
      <NoRecords iconName="briefcase" message="Não encontramos nenhum cargo!" />
    );
  }

  let rows = positions.map((position) => (
    <PositionTableRow
      key={position.id}
      position={position}
      reload={reload}
      active={active}
    />
  ));

  return (
    <Table selectable compact>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Cargo</Table.HeaderCell>
          <Table.HeaderCell>Nível de senioridade</Table.HeaderCell>
          <Table.HeaderCell>Categoria</Table.HeaderCell>
          {active && (
            <Table.HeaderCell>Quantidade de funcionários</Table.HeaderCell>
          )}
          {(user.active_employee
            ? user.active_employee._extra.is_superuser
            : user.is_superuser) &&
            active && <Table.HeaderCell>Ações</Table.HeaderCell>}
        </Table.Row>
      </Table.Header>
      <Table.Body>{rows}</Table.Body>
    </Table>
  );
};
